import { z } from "zod";

export const ReportType = z.enum([
  "EnrollmentStatusBidCredit",
  "EnrollmentStatusTier",
  "BidDeduct",
]);

export type ReportTypeEnum = z.infer<typeof ReportType>;

export const ReportTypeDisplayName: Record<ReportTypeEnum, string> = {
  [ReportType.enum.EnrollmentStatusBidCredit]: "Enrollment Status - Bid Credit",
  [ReportType.enum.EnrollmentStatusTier]: "Enrollment Status - Tier",
  [ReportType.enum.BidDeduct]: "Bid Deduct",
};
